// INDUSTRY_ENUM — fixed industry vocabulary used to scope classification rules.
//
// MUST stay in sync with workflow-api/constants/industries.js. Both files
// reference the same canonical list; the API enforces it at the boundary
// (POST /client/{clientId}/update validates via isValidIndustry).
//
// The "Unspecified" sentinel is the default for clients whose industry has
// not yet been confirmed by a user. It is NEVER returned by the GPT industry
// inferrer and is NEVER selectable in the bookkeeping settings industry dropdown.

export const INDUSTRY_ENUM = [
	"Healthcare",
	"Legal",
	"Consulting",
	"Technology",
	"Construction",
	"Trades & Skilled Services",
	"Food & Beverage",
	"Hospitality",
	"Retail",
	"Real Estate",
	"Transportation",
	"Manufacturing",
	"Advertising",
	"Financial Services",
	"Agriculture",
	"Education",
	"Non-Profit",
	"Professional Services",
];

export const INDUSTRY_UNSPECIFIED = "Unspecified";

export function isValidIndustry(value) {
	return INDUSTRY_ENUM.includes(value);
}

export function toCanonicalIndustry(value) {
	if (!value) return "";
	if (INDUSTRY_ENUM.includes(value)) return value;
	const lower = value.toLowerCase();
	return INDUSTRY_ENUM.find(industry => industry.toLowerCase() === lower) || "";
}

export function isIndustryUnset(value) {
	return !value || value === INDUSTRY_UNSPECIFIED;
}

export default INDUSTRY_ENUM;
